export default "/images/designed-light.svg?8777b5bc2e8eb99e15e61424c221b920";